<!-- Back Navigation Warning Dialog -->
<ui-dialog
    deleteDialog
    (primaryButtonPressed)="goBack()"
    (secondaryButtonPressed)="closeWarningDialog()"
    size="small"
    [open]="isWarningDialogOpen"
    primaryButtonLabel="{{ 'applicant-tracker.discard' | translate }}"
    secondaryButtonLabel="{{ 'applicant-tracker.cancel' | translate }}"
    header="{{ 'applicant-tracker.discardJobPosting' | translate }}"
    (closing)="closeWarningDialog()"
>
    {{ 'applicant-tracker.messages.jobPosting.willNotBeSaved' | translate }}
</ui-dialog>

<ui-dialog
    (primaryButtonPressed)="onSaveDraft(true)"
    (secondaryButtonPressed)="goBack(); closeUnsavedDialog()"
    size="small"
    [open]="isUnsavedDialogOpen"
    primaryButtonLabel="{{ 'applicant-tracker.saveDraft' | translate }}"
    primaryButtonType="primary"
    secondaryButtonType="danger-ghost"
    secondaryButtonLabel="{{ 'applicant-tracker.discardChanges' | translate }}"
    header="{{ 'applicant-tracker.unsavedChanges' | translate }}"
    (closing)="closeUnsavedDialog()"
>
    {{ 'applicant-tracker.messages.jobPosting.unsavedChanges' | translate }}
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isValidationModalOpen"
    (closing)="onClosingValidationModal()"
    header="{{ 'applicant-tracker.unableToPostToIndeed' | translate }}"
>
    <p>{{ 'applicant-tracker.messages.jobPosting.indeedPublishError' | translate }}</p>

    <ul *ngFor="let violation of indeedValidationMessages">
        <li>{{ violation.field }}: <span [innerHTML]="violation.message | sanitizeHtml"></span></li>
    </ul>

    <p>{{ 'applicant-tracker.messages.jobPosting.areYouSureYouWantToSave' | translate }}</p>

    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onClosingValidationModal()">{{
            'applicant-tracker.cancel' | translate
        }}</ui-button>
        <ui-button type="primary" (click)="onSaveWithoutIntegration()">{{
            'applicant-tracker.confirm' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="jobPostingFormTitle" [back]="true" [backRoute]="routeToRedirectTo"></app-header>
    <app-steps
        *ngIf="jobPosting"
        #appSteps
        [labels]="{
            primary: 'applicant-tracker.publishJobPosting',
            secondary: draftSaved ? 'applicant-tracker.draftSaved' : 'applicant-tracker.saveDraft',
            previous: 'previous',
        }"
        [options]="{ showSecondaryAction: showDraftButton() ? 'ALWAYS' : undefined }"
        action="click"
        (onSecondary)="onSaveDraft()"
        [steps]="[basicStep, detailsStep, attachmentStep, questionsStep, helpersStep, reviewStep]"
        (onPrimary)="onSave()"
        (onNext)="
            appSteps.steps[appSteps.activeStep] === reviewStep ? reviewForm.refreshAddressForLinkComponent() : null
        "
    >
        <mat-icon *ngIf="draftSaved" class="secondaryButtonIcon margin-left-1" svgIcon="success"></mat-icon>

        <app-step #basicStep [stepForm]="basicForm" [step]="jobPostingFormTitle" [embeddedCard]="false">
            <app-job-posting-store-basic-information
                #basicForm
                [jobPosting]="jobPosting"
            ></app-job-posting-store-basic-information>
        </app-step>

        <app-step #detailsStep [stepForm]="detailsForm" step="applicant-tracker.information">
            <app-job-posting-store-details-information
                #detailsForm
                [readyToRender]="appSteps.steps[appSteps.activeStep] === detailsStep"
                [jobPosting]="jobPosting"
            ></app-job-posting-store-details-information>
        </app-step>

        <app-step
            #attachmentStep
            [stepForm]="attachmentsForm"
            step="applicant-tracker.documentsAndLinks"
            [title]="'applicant-tracker.documentsAndLinks'"
        >
            <app-job-posting-store-attachments-information
                #attachmentsForm
                [hasQuickApply]="hasQuickApply"
                [jobPosting]="jobPosting"
                [jobAttachments]="jobAttachments"
            ></app-job-posting-store-attachments-information>
        </app-step>

        <app-step
            #questionsStep
            [stepForm]="questionsForm"
            [embeddedCard]="false"
            step="applicant-tracker.question"
            [title]="''"
        >
            <app-job-posting-store-questions-information
                #questionsForm
                [hasQuickApply]="hasQuickApply"
                [hasConsentFlag]="hasConsentFlag"
                [jobPosting]="jobPosting"
                [additionalQuestions]="additionalQuestions"
                [autoArchivingQuestions]="autoArchivingQuestions"
                (refreshData)="refreshQuestions()"
            ></app-job-posting-store-questions-information>
        </app-step>

        <app-step
            #helpersStep
            [stepForm]="helpersForm"
            step="applicant-tracker.fieldsAndHelpers"
            [embeddedCard]="false"
        >
            <app-job-posting-store-helpers-information
                #helpersForm
                [jobPosting]="jobPosting"
            ></app-job-posting-store-helpers-information>
        </app-step>

        <app-step #reviewStep [stepForm]="reviewForm" step="applicant-tracker.summary" [embeddedCard]="false">
            <app-job-posting-store-review-information
                #reviewForm
                [jobPosting]="jobPosting"
                [jobIntegrations]="jobIntegrations"
                [jobAttachments]="jobPostingAttachmentForm?.jobAttachments"
                [additionalQuestions]="additionalQuestions"
                [autoArchivingQuestions]="autoArchivingQuestions"
            ></app-job-posting-store-review-information>
        </app-step>
    </app-steps>
</div>
